import { useCallback } from 'react';
import { useRegisterResponseAction } from '../../context/useRegisterResponseAction';
import { isEmptyValue } from '../../../utils/managerUtils';
import { ResponseActionScope } from '../../../types/context';

export const useRemoveRowsAction = (
  removeRows: (ids: string[]) => void,
  scopeOverride?: ResponseActionScope
): void => {
  const handler = useCallback(
    (params: unknown) => {
      if (isEmptyValue(params)) return;

      let value: string[] = [];

      if (typeof params === 'string') {
        value = [params];
      }

      if (Array.isArray(params)) {
        value = params.map(String);
      }

      removeRows(value);
    },
    [removeRows]
  );

  useRegisterResponseAction('removeRows', handler, scopeOverride);
};
